import css from './MediaListLink.module.scss';

export type MediaListLinkVariant = 'error' | 'success' | 'warning' | 'info';

/**
 * Dumb call-to-action button that opens a `FailedMediaListModal` (or any
 * similar list-of-media modal). Originally factored out of `BatchCard`'s
 * red "View & retry N failed files" pill — kept the same visual shape but
 * accepts a `variant` so the same affordance can render in error (red),
 * success (green) or warning (yellow) modes.
 *
 * Renders as `{action} {subtext?}` with a small arrow icon on the right.
 * Pass `disabled` when the trigger should appear but be inert (e.g. while
 * the parent is still loading the details payload).
 */
export const MediaListLink = ({
  action,
  subtext,
  variant = 'error',
  onClick,
  disabled,
}: {
  /** Primary verb-led label, e.g. "View & retry", "View deleted files". */
  action: string;
  /** Optional secondary fragment, e.g. "3 failed files". */
  subtext?: string;
  variant?: MediaListLinkVariant;
  onClick: () => void;
  disabled?: boolean;
}) => {
  const variantClass =
    variant === 'success'
      ? css.success
      : variant === 'warning'
        ? css.warning
        : variant === 'info'
          ? css.info
          : css.error;
  return (
    <button className={`${css.link} ${variantClass}`} onClick={onClick} disabled={disabled}>
      <span>
        <span className={css.action}>{action}</span>
        {subtext && <span className={css.subtext}> {subtext}</span>}
      </span>
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M7 17L17 7M9 7h8v8" />
      </svg>
    </button>
  );
};
